import { d as s } from "./index.es26.js";
var c, g;
function q() {
  if (g) return c;
  g = 1;
  var a = s.isTag;
  c = {
    filter: l,
    find: d,
    findOneChild: v,
    findOne: e,
    existsOne: o,
    findAll: y
  };
  function l(i, n, f, r) {
    return Array.isArray(n) || (n = [n]), (typeof r != "number" || !isFinite(r)) && (r = 1 / 0), d(i, n, f !== !1, r);
  }
  function d(i, n, f, r) {
    for (var u = [], t, h = 0, p = n.length; h < p && !(i(n[h]) && (u.push(n[h]), --r <= 0) || (t = n[h].children, f && t && t.length > 0 && (t = d(i, t, f, r), u = u.concat(t), r -= t.length, r <= 0))); h++)
      ;
    return u;
  }
  function v(i, n) {
    for (var f = 0, r = n.length; f < r; f++)
      if (i(n[f])) return n[f];
    return null;
  }
  function e(i, n) {
    for (var f = null, r = 0, u = n.length; r < u && !f; r++)
      if (a(n[r]))
        i(n[r]) ? f = n[r] : n[r].children.length > 0 && (f = e(i, n[r].children));
      else continue;
    return f;
  }
  function o(i, n) {
    for (var f = 0, r = n.length; f < r; f++)
      if (a(n[f]) && (i(n[f]) || n[f].children.length > 0 && o(i, n[f].children)))
        return !0;
    return !1;
  }
  function y(i, n) {
    for (var f = [], r = n.slice(); r.length; ) {
      var u = r.shift();
      a(u) && (u.children && u.children.length > 0 && r.unshift.apply(r, u.children), i(u) && f.push(u));
    }
    return f;
  }
  return c;
}
export {
  q as __require
};
//# sourceMappingURL=index.es53.js.map
